"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppConfigBanner = exports.appConfigBannerSchema = exports.isBanner = exports.bannerSchema = void 0;
var yup = require("yup");
var ScheduledItem_1 = require("./ScheduledItem");
var Image_1 = require("./Image");
exports.bannerSchema = ScheduledItem_1.scheduledItemSchema.shape({
    id: yup.string().required(),
    image: Image_1.imageSchema.required(),
    url: yup.string().optional(),
    collectionId: yup.string().optional(),
    isSwipeTransition: yup.boolean().optional(),
});
function isBanner(obj) {
    return exports.bannerSchema.isValidSync(obj);
}
exports.isBanner = isBanner;
/**
 * @deprecated use `bannerSchema` instead!
 */
exports.appConfigBannerSchema = exports.bannerSchema;
/**
 * @deprecated use `isBanner` instead!
 */
exports.isAppConfigBanner = isBanner;
